import $ from 'jquery';

$(function () {
    hoverMenu();

    $('.ow-megamenu__tabs-tab').on("click", function () {
        const tab = $(this).data('tab');
        const parent = $(this).closest('.ow-megamenu__inner');
        parent.find('.ow-megamenu__tabs-tab').removeClass("active");
        parent.find('.ow-megamenu__tabs-content-single').removeClass("active");
        parent.find('.ow-megamenu__cta-block-tab-related').removeClass("active");
        $(this).addClass("active");
        parent.find('.ow-megamenu__tabs-content-single[data-tab="' + tab + '"]').addClass("active");
        parent.find('.ow-megamenu__cta-block-tab-related[data-tab="' + tab + '"]').addClass("active");
    });

    var megamenu = "";

    function hoverMenu() {
        $('.ow-megamenu')
            .on("mouseenter", function () {
                $("body").addClass('ow_hover_menu');
                if ($(this).children("a").attr("data-megamenu")) {
                    $(".ow-megamenu__inner").hide()
                    megamenu = $(this).children("a").attr("data-megamenu");
                }
                $("." + megamenu).css('display', 'flex');

            })
            .on("mouseleave", function () {
                $("body").removeClass('ow_hover_menu')
            })
    }
});

